module.exports = __webpack_public_path__ + "static/media/Search Sanctions Kurum ID.ad3b6656.xlsx";